<template>
  <div>
    <div class="tab">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <el-form ref="form" :model="form" label-width="120px" size="mini">
            <el-row>
              <el-col :span="6">
                <el-form-item prop="albumTitle" label="姓名：">
                  <el-input size="small" v-model="form.albumTitle"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="classCode" label="用户名：">
                  <el-input size="small" v-model="form.classCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="type" label="类型：">
                  <el-select
                    ref="applyTypeSelect"
                    v-model="form.type"
                    placeholder="-不限-"
                    @visible-change="visibleChange"
                  >
                    <el-option
                      v-for="item in typeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="btn" style="text-align: center">
              <el-row>
                <el-button type="primary" size="mini" @click="search">
                  确定
                </el-button>
                <el-button size="mini" @click="toggle">收起</el-button>
                <el-button size="mini" @click="delAll"> 清空 </el-button>
              </el-row>
            </div>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <div class="control">
        <el-button type="primary" @click="toggle">筛选</el-button>
        <el-button type="primary">导出筛选结果</el-button>
      </div>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column prop="id" label="ID" align="center"></el-table-column>
      <el-table-column prop="albumTitle" label="姓名" align="center">
      </el-table-column>
      <el-table-column prop="albumTitle" label="手机号（账号）" align="center">
      </el-table-column>
      <el-table-column
        prop="classCode"
        label="课程名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="majorName"
        label="章节名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="cover"
        label="学习累计时长"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="year"
        label="学习状态"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="term"
        label="类型"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="price"
        label="开始学习时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="applyType"
        label="完成学习时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="isOvert"
        label="结束学习时间"
        align="center"
      ></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: [],
      form: {},
      typeList: [
        { label: '视频', value: '1' },
        { label: '文档', value: '2' },
        { label: '练习', value: '3' },
        { label: '测验', value: '4' },
        { label: '考试', value: '5' },
        { label: '资料', value: '6' },
      ],
      tableData: [{}],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      selectedList: [],
    }
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.enterQuery)
  },
  methods: {
    //搜索的折叠面板
    toggle() {
      if (this.activeNames.length > 0) {
        this.activeNames = []
        window.removeEventListener('keyup', this.enterQuery)
      } else {
        this.activeNames = ['1']
        window.addEventListener('keyup', this.enterQuery)
      }
    },
    search() {},
    enterQuery(e) {
      if (e.key === 'Enter') {
        this.search()
      }
    },
    delAll() {},
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getCourseRecordList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getCourseRecordList()
    },
    visibleChange(e) {
      if (!e) {
        this.$refs.applyTypeSelect.blur()
      }
    },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/classManagement.scss';
</style>